import { useCache, CACHE_KEY } from '@/hooks/web/useCache'
import { TokenType } from '@/api/login/types'

const { wsCache } = useCache()

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// 获取token
export const getAccessToken = () => {
  // 此处与TokenKey相同，此写法解决初始化时Cookies中不存在TokenKey报错
  return wsCache.get(AccessTokenKey) ? wsCache.get(AccessTokenKey) : wsCache.get('ACCESS_TOKEN')
}

// 刷新token
export const getRefreshToken = () => {
  return wsCache.get(RefreshTokenKey)
}

// 设置token
export const setToken = (token: TokenType) => {
  wsCache.set(RefreshTokenKey, token.refreshToken)
  wsCache.set(AccessTokenKey, token.accessToken)
  // token 变更（登录/切换用户）后旧用户缓存不可信，清除以确保下次 setUserInfoAction 重新请求 /auth/me
  wsCache.delete(CACHE_KEY.USER)
  wsCache.delete(CACHE_KEY.ROLE_ROUTERS)
}

// 删除token
export const removeToken = () => {
  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}
// ========== 账号相关 ==========

export type LoginFormType = {
  tenantName?: string
  phone: string
  /** 仅登录页内存内使用，不落缓存；缓存一律回填空串 */
  password: string
  rememberMe: boolean
}

export const getLoginForm = () => {
  const loginForm: LoginFormType = wsCache.get(CACHE_KEY.LoginForm)
  if (!loginForm) return loginForm
  // 密码不再落缓存：历史版本加密存的密码在此丢弃，仅回填账号
  return { ...loginForm, password: '' }
}

/** 记住账号：只存账号与勾选状态，不持久化密码 */
export const setLoginForm = (loginForm: LoginFormType) => {
  wsCache.set(
    CACHE_KEY.LoginForm,
    {
      tenantName: loginForm.tenantName,
      phone: loginForm.phone,
      password: '',
      rememberMe: loginForm.rememberMe
    },
    { exp: 30 * 24 * 60 * 60 }
  )
}

export const removeLoginForm = () => {
  wsCache.delete(CACHE_KEY.LoginForm)
}

// ========== 租户相关 ==========

export const getTenantId = () => {
  return wsCache.get(CACHE_KEY.TenantId)
}

export const setTenantId = (username: string) => {
  wsCache.set(CACHE_KEY.TenantId, username)
}
